import BVAInput from "../../../components/BVAInput/BVAInput";

export default function InputItem({ name, data, handleChange = () => {}, bold = false, disabled = false, endLabel = "$" }) {
  return (
    <div className="flex justify-between items-center my-3 px-5">
      <div
        className={`items-center text-lg ${bold ? "font-semibold" : ""}`}
      >
        {name}
      </div>
      <BVAInput
        size="small"
        width="170px"
        textAlign="start"
        disabled={disabled}
        endAdornment
        endAdornmentLabel={endLabel}
        value={data}
        onChange={handleChange}
      />
    </div>
  );
}
